import React from 'react';
import {isMobile, isTablet} from 'react-device-detect';
import Cookie from 'js-cookie';
import {connect} from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";
import sortBy from "lodash/sortBy";
import findIndex from "lodash/findIndex";
import cloneDeep from "lodash/cloneDeep";
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import en from 'date-fns/locale/en';
import {injectIntl} from '@s7ui-kit/s7ui-kit'
import { InView } from 'react-intersection-observer';
import changePrepositionForm from '../../services/utils/changePrepositionForm';

import {SliderSlick} from '../../containers/SliderSlick';
import SaleBanner from '../../components/common/SaleBanner/SaleBanner';
import SummerBanner from '../../components/common/SummerBanner/SummerBanner';
import VideoBanner from '../common/VideoBanner/VideoBanner';
import pushGA from '../../services/utils/pushGA';
import {analyticsBannerClick, analyticsBannerLoad, analyticsBannerShow} from '../../services/analytics/analyticsBanners';
import {loadPersonalizedBanners, loadTravelers} from '../../services/services/AdsService';
import getResizeImageUrl from "../../services/utils/getResizeImageUrl";
import {Declension} from '../../services/services/Declension';

import styles from './main-slider.css';
import GeoService from '../../services/services/GeoService';
import {OW, RT} from "../../services/constants/App";
import {filterTravelersWithBirthday} from "./sliderUtils";

const BANNER_PLACE = 'HOME_ADS_PLACE';
const NAMESPACE = 'default';

//для теста
//import blurImage from '../../assets/images/sale-banners/feather-left-600.png';
//import focusImage from '../../assets/images/sale-banners/feather-right-600.png';

//example custom settings sale banner from Cabin
const saleBannerSettings = {
    "saleBanner": true,
    "blurImage": "e6fa42a3-b24d-4bbf-a601-309713480e04",
    "focusImage": "711b4186-179f-4d3c-aa4d-67594f23ccea",
    "finish": "2020-09-14T09:55:50.417",
    "bgColor": "#2290BC",
    "textColor": "#2290BC"
};

class MainSlider extends React.Component {
    constructor() {
        super();
        this.bannersSlider = React.createRef();
    }

    state = {
        sourceBanners: [],
        isNavigationGuaranteed: true,
        typeSlideChange: 'auto',
        ffpMemberCookie: '',
        bannerOptions: {},
        isBannerLoaded: false,
        lastSearch: {},
        isSaleBanner: false,
        travelers: {},
        giftBannerShowed: false,
        bdayBanner: {},
        isFirstMount: true,
        isInfinite: false,
        isSliderInView: false
    };

    componentDidMount() {
        const {lang, profile, getMessage, words} = this.props;
        getMessage(words, 'com.s7.main.page.slider.price.preposition.subtitle');
        getMessage(words, 'com.s7.main.page.slider.price.grow.title');
        getMessage(words, 'com.s7.main.page.slider.price.grow.subtitle.before');
        getMessage(words, 'com.s7.main.page.slider.price.grow.subtitle.after');
        getMessage(words, 'com.s7.main.page.slider.price.shrink.title');
        getMessage(words, 'com.s7.main.page.slider.price.shrink.subtitle.before');
        getMessage(words, 'com.s7.main.page.slider.price.shrink.subtitle.after');
        getMessage(words, 'com.s7.main.page.slider.bday.banner.link');
        getMessage(words, 'com.s7.main.page.slider.bday.title.for.all');
        getMessage(words, 'com.s7.main.page.slider.bday.subtitle.for.all');
        getMessage(words, 'com.s7.main.page.slider.bday.title.for.one');
        getMessage(words, 'com.s7.main.page.slider.bday.subtitle.for.one');
        getMessage(words, 'com.s7.main.page.slider.previous');
        getMessage(words, 'com.s7.main.page.slider.next');
        getMessage(words, 'com.s7.main.page.slider.dotname');


        const options = {
            lang,
            personCookie: Cookie.get('ssdkl'),
            place: BANNER_PLACE,
            ns: NAMESPACE,
        };
        this.setState({ffpMemberCookie: Cookie.get('ffpMember')});

        const airportCookie = Cookie.get('airport');
        const value = airportCookie ? airportCookie : GeoService.getUserCityByGeo().airportCode;
        if (value) {
            options.userAirportCode = value;
        }

        if (isTablet) {
            options.platform = 'TABLET';
        } else if (isMobile) {
            options.platform = 'MOBILE';
        } else {
            options.platform = 'DESKTOP';
        }

        this.setState({bannerOptions: options});

        if (profile) options.profileId = profile.id;
        this.loadBanners(options, true);
    }

    getPersonalizedBanner = (lastSearch) => {
        const { getMessage, words, lang} = this.props;
        const declension = new Declension(words, getMessage);

        if (lastSearch.departureDate) {
            const now = Date.now();
            const depDate = new Date(lastSearch.departureDate).getTime();
            if (depDate - now < 0) return;
        }

        const result = {};
        if (lastSearch.state === 'GROW') {
            result.title = getMessage(words, 'com.s7.main.page.slider.price.grow.title');
            result.subTitle = getMessage(words, 'com.s7.main.page.slider.price.grow.subtitle.before') +
                changePrepositionForm(getMessage(words, 'com.s7.main.page.slider.price.preposition.subtitle'), lastSearch.arrival) +
                '&nbsp;' +
                declension.toCity({city: lastSearch.arrival, iata: lastSearch.arrivalPlace}) +
                getMessage(words, 'com.s7.main.page.slider.price.grow.subtitle.after');
            result.image = "by-path/raw/images/banners/static_price-grow1920x380_2.jpg";
            result.imageMobile = "by-path/raw/images/banners/static_price-grow1920x380_2.jpg";
            result.code = "MainPageHeroBannerGrow";
        }
        if (lastSearch.state === 'SHRINK') {
            result.title = getMessage(words, 'com.s7.main.page.slider.price.shrink.title');
            result.subTitle = getMessage(words, 'com.s7.main.page.slider.price.shrink.subtitle.before') +
                changePrepositionForm(getMessage(words, 'com.s7.main.page.slider.price.preposition.subtitle'), lastSearch.arrival) +
                '&nbsp;' +
                declension.toCity({city: lastSearch.arrival, iata: lastSearch.arrivalPlace}) +
                getMessage(words, 'com.s7.main.page.slider.price.shrink.subtitle.after');
            result.image = "by-path/raw/images/banners/static_price-shrink1920x380_2.jpg";
            result.imageMobile = "by-path/raw/images/banners/static_price-shrink1920x380_2.jpg";
            result.code = "MainPageHeroBannerShrink";
        }
        result.subTitleForMobile = result.subTitle;
        if (lastSearch.routeType === OW) {
            result.link = `https://www.s7.ru/external/IBE_redirect.dot?searchType=NORMAL&journeySpan=${OW}&origin=${lastSearch.departurePlace}&destination=${lastSearch.arrivalPlace}&departureDate=${format(lastSearch.departureDate, 'YYYY-MM-DD')}&cabinClass=E&numAdults=1&lang=${lang}&ibe_medium=s7PortalTimeTable&CUR=${lastSearch.currency}`;
            result.eventLabel = `FROM:${lastSearch.departurePlace};TO:${lastSearch.arrivalPlace};FWAY:${OW};DDATE:${format(lastSearch.departureDate, 'YYYY-MM-DD')};RDATE:none;PRICE:${lastSearch.state === 'GROW' ? 'up' : lastSearch.state === 'SHRINK' ? 'down' : 'none'}`;
        } else {
            result.link = `https://www.s7.ru/external/IBE_redirect.dot?searchType=NORMAL&journeySpan=${RT}&origin=${lastSearch.departurePlace}&destination=${lastSearch.arrivalPlace}&departureDate=${format(lastSearch.departureDate, 'YYYY-MM-DD')}&returnDate=${format(lastSearch.arrivalDate, 'YYYY-MM-DD')}&cabinClass=E&numAdults=1&lang=${lang}&ibe_medium=s7PortalTimeTable&CUR=${lastSearch.currency}`;
            result.eventLabel = `FROM:${lastSearch.departurePlace};TO:${lastSearch.arrivalPlace};FWAY:${RT};DDATE:${format(lastSearch.departureDate, 'YYYY-MM-DD')};RDATE:${format(lastSearch.arrivalDate, 'YYYY-MM-DD')};PRICE:${lastSearch.state === 'GROW' ? 'up' : lastSearch.state === 'SHRINK' ? 'down' : 'none'}`;
        }
        result.heroBanner = true;
        result.subTitleOnlyForDesktop = false;
        result.settings = {
            openLinkInNewTab: false
        };

        return result;
    };

    componentDidUpdate(prevProps) {
        const { lastSearches, lang } = this.props;
        const { bannerOptions, sourceBanners } = this.state;
        const s7PageInit = typeof(window.s7PageInit)!=='undefined' ? window.s7PageInit : {};

        let personalizedBanner = {};
        if (
            ('mainPageHeroBannerGrowShrink' in s7PageInit && s7PageInit.mainPageHeroBannerGrowShrink) && lang && (lang === 'ru' || lang === 'en') &&
            lastSearches && lastSearches[0] && lastSearches[0].state &&
            prevProps.lastSearches !== lastSearches
        ) {
            let inSevenDays = 7;
            if (lastSearches[0].state === 'GROW' && !sessionStorage.getItem('heroBannerGrowShowed') && !Cookie.get('heroBannerGrowShowed')) {
                Cookie.set('heroBannerGrowShowed', 'true', {expires: inSevenDays});
                sessionStorage.setItem('heroBannerGrowShowed', 'true');
                personalizedBanner = this.getPersonalizedBanner(lastSearches[0]);
                this.setState({sourceBanners: [personalizedBanner, ...sourceBanners]});
            }
            if (lastSearches[0].state === 'SHRINK' && !sessionStorage.getItem('heroBannerShrinkShowed') && !Cookie.get('heroBannerShrinkShowed')) {
                Cookie.set('heroBannerShrinkShowed', 'true', {expires: inSevenDays});
                sessionStorage.setItem('heroBannerShrinkShowed', 'true');
                personalizedBanner = this.getPersonalizedBanner(lastSearches[0]) ;
                this.setState({sourceBanners: [personalizedBanner, ...sourceBanners]});
            }
        }


        if (this.props.profile && !isEmpty(this.props.profile) && ((prevProps.profile && this.props.profile.id !== prevProps.profile.id ) || isEmpty(prevProps.profile))) {
            const newOptions = JSON.parse(JSON.stringify(bannerOptions));
            newOptions.profileId = this.props.profile.id;
            this.setState({bannerOptions: newOptions});
            this.loadBanners(newOptions, false);
        } else if(isEmpty(this.props.profile) && !isEmpty(prevProps.profile)){
            const newOptionsNotAuth = JSON.parse(JSON.stringify(bannerOptions));
            newOptionsNotAuth.profileId = "";
            this.setState({bannerOptions: newOptionsNotAuth});
            this.loadBanners(newOptionsNotAuth, false);
        } else if(sourceBanners.length > 0){
            this.checkAndAddCustomBanner();
        }
    }

    isExsistNewBannerByImageUrl = imageUrl =>{
        const { sourceBanners } = this.state;
        return sourceBanners.filter(item => item.imageUrl === imageUrl).length > 0;
    };

    checkAndAddCustomBanner = () => {
        const { sourceBanners } = this.state;

        if (!isUndefined(window.addedNewBanners) && window.addedNewBanners.length > 0) {
            window.addedNewBanners.map(newBanner => {
                if (newBanner.imageUrl && !this.isExsistNewBannerByImageUrl(newBanner.imageUrl)) {
                    if (newBanner.sort) {
                        const {tablet, mobile, def} = newBanner.sort;
                        if (isTablet && !isUndefined(tablet)) {
                            sourceBanners.splice(tablet, 0, newBanner);
                            this.setState({...sourceBanners});
                        } else if (isMobile && !isUndefined(mobile)) {
                            sourceBanners.splice(mobile, 0, newBanner);
                            this.setState({...sourceBanners});
                        } else if (!isUndefined(def)) {
                            sourceBanners.splice(def, 0, newBanner);
                            this.setState({...sourceBanners});
                        } else {
                            sourceBanners.push(newBanner);
                            this.setState({...sourceBanners});
                        }
                    } else {
                        sourceBanners.push(newBanner);
                        this.setState({...sourceBanners});
                    }}
            });
        }
    };

    loadBanners = (options, firstLoad, personalizedBanner) => {
        loadPersonalizedBanners(options).then(data => {
            if(!data || !Array.isArray(data)){
                return;
            }
            const dataDraft = cloneDeep(data);

            const bdayBanner = dataDraft.find(banner => banner.code === 'B-DAY');
            const bdayBannerIndex = findIndex(dataDraft, (banner) => banner.code === 'B-DAY');

            if(bdayBanner && bdayBannerIndex > -1) {
                dataDraft.splice(bdayBannerIndex, 1);
            }

            if (!isEmpty(personalizedBanner)) dataDraft.shift(personalizedBanner);

            this.setState(prevState =>{
                return{
                    sourceBanners: dataDraft,
                    bdayBanner: !isUndefined(bdayBanner) ? bdayBanner : prevState.bdayBanner
                }
            }, () => {
                this.renderBdayBanner(bdayBannerIndex);
            })
        }).catch(error =>console.log(error));
    };

    renderBdayBanner = bdayBannerIndex => {
        const { bdayBanner, sourceBanners } = this.state;
        const { profile } = this.props;

        if(isEmpty(sourceBanners)) {
            return null;
        }

        if(bdayBannerIndex > -1 && profile && profile.id){
            loadTravelers({profileId: profile.id})
                .then((travelers) => {
                    filterTravelersWithBirthday(travelers, (travelersWithBirthday) => {
                        if (!travelersWithBirthday || !travelersWithBirthday.length) {
                            return null;
                        }

                        this.setState({
                            travelers: travelersWithBirthday,
                            giftBannerShowed: true,
                            sourceBanners: [bdayBanner, ...sourceBanners],
                        });
                        if(this.bannersSlider && this.bannersSlider.current) this.bannersSlider.current.slickGoTo(0);
                    });
                })
                .catch((error) => {
                    throw new Error(error);
                })
        }
    };

    filterBanners = () => {
        const {sourceBanners} = this.state;

        if (sourceBanners.length > 0) {
            this.checkAndAddCustomBanner();

            let result = sortBy(sourceBanners, item => item && item.settings && item.settings.custom && item.settings.custom.onlyFirstPlace);

            const maxSlides = isMobile && !isTablet ? 4 : 7;

            return result.slice(0, maxSlides);
        } else return [];
    };

    parametersReplacer = (link) => {
        if (link.indexOf('{ffp}') !== -1 && this.state.ffpMemberCookie > 0) {
            link = link.replace('{ffp}', this.state.ffpMemberCookie);
        }
        if (link.indexOf('?ffp=') !== -1 && !(this.state.ffpMemberCookie > 0)) {
            link = link.replace('?ffp=', '');
        }
        return link;
    };

    renderSaleBanner = banner => {
        if(banner.settings && banner.settings.custom && banner.settings.custom.saleBanner){
            const { finish, blurImage, focusImage, title, bgColor, textColor, videoBannerDesktop, videoBannerMobile, videoDesktopLink, videoMobileLink, videoBannerDesktopOverlay, videoBannerMobileOverlay } = banner.settings.custom;

            return <SaleBanner
                finish={finish}
                blurImage={getResizeImageUrl({
                    imageCabinId: blurImage,
                    webpQuality: banner.settings.webpQuality,
                    otherQuality: banner.settings.otherQuality
                })}
                focusImage={getResizeImageUrl({
                    imageCabinId: focusImage,
                    webpQuality: banner.settings.webpQuality,
                    otherQuality: banner.settings.otherQuality
                })}
                title={title}
                bgColor={bgColor}
                textColor={textColor}
                updateTime={this.state.isSaleBanner}
                videoBannerDesktop={videoBannerDesktop}
                videoBannerMobile={videoBannerMobile}
                videoDesktopLink={videoDesktopLink}
                videoMobileLink={videoMobileLink}
                videoBannerDesktopOverlay={videoBannerDesktopOverlay}
                videoBannerMobileOverlay={videoBannerMobileOverlay}
                isFirstMount={this.state.isFirstMount}
            />
        }
    };

    renderSummerBanner = banner => {
        return <SummerBanner {...banner} isMobile/>
    }

    renderVideoBanner = banner => {
        const { videoBannerDesktop, videoBannerMobile, videoDesktopLink, videoMobileLink, videoBannerDesktopOverlay, videoBannerMobileOverlay } = banner.settings.custom;
        
        return <VideoBanner
            videoBannerDesktop={videoBannerDesktop}
            videoBannerMobile={videoBannerMobile}
            videoDesktopLink={videoDesktopLink}
            videoMobileLink={videoMobileLink}
            videoBannerDesktopOverlay={videoBannerDesktopOverlay}
            videoBannerMobileOverlay={videoBannerMobileOverlay}
            isFirstMount={this.state.isFirstMount}
        />
    }

    changeInView = inView => {
        this.setState({isSliderInView: inView});
    };

    render() {
        const { isNavigationGuaranteed, isInfinite } = this.state;
        const { onNewMainPage, getMessage, words } = this.props;
        const bannerItems = this.filterBanners();

        const getTypeEventActionPrefix = (bannerItem) => {
            if (bannerItem.personalized && bannerItem.personalized === true) {
                return 'Personal';
            } else if (bannerItem.heroBanner && bannerItem.heroBanner === true) {
                return 'Hero';
            } else {
                return 'Common';
            }
        };

        const getBannerTitleAndSubtitle = () => {

            const { travelers } = this.state;
            const { getMessage, words, lang } = this.props;
            let bannerTitle = '';

            if (!travelers || travelers.length === 0 || isEmpty(travelers)) {
                return bannerTitle;
            }

            if (travelers.length > 1) {
                return {
                    title: getMessage(words, 'com.s7.main.page.slider.bday.title.for.all'),
                    subtitle: getMessage(words, 'com.s7.main.page.slider.bday.subtitle.for.all')
                };
            }

            travelers[0].names.map((name) => {
                const formattedBdayDate = format(travelers[0].birthday, "D MMMM", { locale: lang === 'ru' ? ru : en }).replace(' ', '\u00a0');

                bannerTitle = getMessage(words, 'com.s7.main.page.slider.bday.title.for.one')
                    .replace('${name}', name.firstName)
                    .replace('${date}', formattedBdayDate);
            });

            return {
                title: bannerTitle,
                subtitle: getMessage(words, 'com.s7.main.page.slider.bday.subtitle.for.one'),
            };
        }

        const ecomParamsForGA = (items) => {
            if (items?.length > 1) {
                return items.map((item) => {
                    const { code } = item;
                    return {
                        item_id: code,
                        item_name: 'banner',
                        item_variant: 'small',
                        location_id: 's7_main',
                    }
                })
            }
            return [{
                item_id: items?.code || '',
                item_name: 'banner',
                item_variant: 'small',
                location_id: 's7_main',
            }]
        };

        return (
            <div
                className={classNames({
                    [styles.bannerContainer]: true,
                    [styles.mainpageCarousel]: onNewMainPage
                })}
            >
                <InView onChange={inView => this.changeInView(inView)}>
                {bannerItems.length > 0 && (
                    <SliderSlick
                        settings={{
                            dots: true,
                            infinite: isInfinite,
                            useTransform: false,
                            arrows: onNewMainPage,
                            speed: 500,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            autoplay: true,
                            autoplaySpeed: 6000,
                            lazyLoad: 'progressive',
                            prevArrow: <button type="button" class="slick-prev">{getMessage(words, 'com.s7.main.page.slider.previous')}</button>,
                            nextArrow: <button type="button" class="slick-next">{getMessage(words, 'com.s7.main.page.slider.next')}</button>,
                            appendDots: dots => {
                                return (
                                    <ul>
                                        {React.Children.map(dots, dot => {
                                            const slideNumber = dot.key ? Number(dot.key) + 1 : '';
                                            return React.cloneElement(dot, {
                                                onClick: () => {
                                                    this.setState({ typeSlideChange: 'Click_dots' });
                                                },
                                                title: `${getMessage(words, 'com.s7.main.page.slider.dotname')} ${slideNumber}` 
                                            });
                                        })}
                                    </ul>
                                );
                            },
                            beforeChange: (oldIndex, newIndex) => {
                                this.setState({ isNavigationGuaranteed: false });
                                const bannerNewInd = bannerItems[newIndex];

                                if(bannerNewInd.settings && bannerNewInd.settings.custom && bannerNewInd.settings.custom.saleBanner) {
                                    this.setState({
                                        isSaleBanner: true
                                    })
                                }
                            },
                            afterChange: i => {
                                const { typeSlideChange, isSliderInView } = this.state;
                                this.setState({isInfinite: true});

                                if (bannerItems.length !== 1 && isUndefined(bannerItems[i].ga4ShowSended) && isSliderInView) {
                                    bannerItems[i] && analyticsBannerShow(ecomParamsForGA(bannerItems[i]));
                                    bannerItems[i].ga4ShowSended = true;
                                }

                                if (bannerItems.length !== 1 && isUndefined(bannerItems[i].gaShowSended)) {
                                    bannerItems[i] && pushGA(
                                        'PORTAL Banners',
                                        `${getTypeEventActionPrefix(bannerItems[i])} Show`,
                                        bannerItems[i].eventLabel ? bannerItems[i].eventLabel : `CONTENT:bigMain;NAME:${bannerItems[i].code};`,
                                        { eventValue: i + 1, eventUX: typeSlideChange }
                                    );
                                    bannerItems[i].gaShowSended = true;
                                }

                                this.setState({
                                    isNavigationGuaranteed: true,
                                    typeSlideChange: 'auto',
                                });
                            },
                            onInit: () => {
                                const { typeSlideChange, isSliderInView } = this.state;

                                bannerItems.forEach( (item, i) => {
                                    if (item.heroBanner && item.heroBanner === true) return;
                                    pushGA(
                                        'PORTAL Banners',
                                        `${getTypeEventActionPrefix(item)} Load`,
                                        item.eventLabel ? item.eventLabel : `Content:bigMain;NAME:${item.code};`,
                                        { eventValue: i + 1, eventUX: undefined }
                                    );

                                    if (i === 0) {
                                        if (isUndefined(bannerItems[i].gaShowSended)) {
                                            bannerItems[i] && pushGA(
                                                'PORTAL Banners',
                                                `${getTypeEventActionPrefix(bannerItems[i])} Show`,
                                                bannerItems[i].eventLabel ? bannerItems[i].eventLabel : `CONTENT:bigMain;NAME:${bannerItems[i].code};`,
                                                {eventValue: i + 1, eventUX: typeSlideChange}
                                            );
                                            bannerItems[i].gaShowSended = true;
                                        }

                                        if (isUndefined(bannerItems[i].ga4ShowSended) && isSliderInView) {
                                            bannerItems[i] && analyticsBannerShow(ecomParamsForGA(bannerItems[i]));
                                            bannerItems[i].ga4ShowSended = true;
                                        }
                                    }
                                });
                                analyticsBannerLoad(ecomParamsForGA(bannerItems));
                            },
                            onReInit: () => {
                                const { isSliderInView } = this.state;

                                if (this.state.isFirstMount === true) {
                                    this.setState({isFirstMount: false});
                                }

                                if (!isUndefined(bannerItems[0].heroBanner) && isUndefined(bannerItems[0].gaShowSended)) {
                                    pushGA(
                                        'PORTAL Banners',
                                        `Hero Show`,
                                        bannerItems[0].eventLabel ? bannerItems[0].eventLabel : '',
                                        {eventValue: 0, eventUX: 'auto', eventInteraction: 1}
                                    );
                                    analyticsBannerShow(ecomParamsForGA(bannerItems[0] || ''));
                                    bannerItems[0].gaShowSended = true;
                                }

                                if (!isUndefined(bannerItems[0].heroBanner) && isUndefined(bannerItems[0].ga4ShowSended) && isSliderInView) {
                                    analyticsBannerShow(ecomParamsForGA(bannerItems[0] || ''));
                                    bannerItems[0].ga4ShowSended = true;
                                }
                            },
                        }}
                        ref={slider => {
                            if(slider && slider.slider) {
                                this.bannersSlider = slider.slider;
                            }
                        }}
                    >
                        {bannerItems.map((banner, i) => {

                            if (banner.code === 'B-DAY') {
                                const bannerTitles = getBannerTitleAndSubtitle();
                                if (isUndefined(bannerTitles.title) || isUndefined(bannerTitles.subtitle)) {
                                    return false;
                                } else if (this.state.giftBannerShowed) {
                                    banner.title = bannerTitles.title;
                                    banner.subTitle = bannerTitles.subtitle;
                                    banner.subTitleForMobile = bannerTitles.subtitle;
                                    banner.isMobileFontSize = true;
                                    banner.link = getMessage(words, 'com.s7.main.page.slider.bday.banner.link');
                                }
                            }

                            let bannerTitleStyle = {};
                            let bannerLink = banner.link;

                            if (bannerLink) {
                                bannerLink = this.parametersReplacer(bannerLink);
                            }

                            if(banner.settings && banner.settings.titleColor) {
                                bannerTitleStyle.color = banner.settings.titleColor;
                            }

                            if(banner.settings && banner.settings.custom && banner.settings.custom.saleBanner) {
                                banner.saleBanner = banner.settings.custom.saleBanner;
                                banner.saleSettings =  banner.settings.custom;
                            }

                            let imageUrl = '';
                            if (isMobile && !isTablet && banner.imageMobile) {
                                imageUrl += banner.imageMobile;
                            } else if (isMobile && isTablet && banner.imageTablet) {
                                imageUrl += banner.imageTablet;
                            } else {
                                imageUrl += banner.image;
                            }

                            let absoluteImageUrl = '';
                            if (isMobile && !isTablet && banner.imageUrlMobile) {
                                absoluteImageUrl = banner.imageUrlMobile;
                            } else if (isMobile && isTablet && banner.imageUrlTablet) {
                                absoluteImageUrl = banner.imageUrlTablet;
                            } else if(banner.imageUrl){
                                absoluteImageUrl = banner.imageUrl;
                            }

                            if (imageUrl !== '' || absoluteImageUrl !== '') imageUrl = `url(${absoluteImageUrl === '' ? getResizeImageUrl({
                                imageCabinId: imageUrl,
                                webpQuality: banner.settings.webpQuality,
                                otherQuality: banner.settings.otherQuality
                            }) : getResizeImageUrl({
                                imageAbsoluteUrl: absoluteImageUrl,
                                webpQuality: banner.settings.webpQuality,
                                otherQuality: banner.settings.otherQuality
                            })})`;

                            const { settings } = banner;
                            return (
                                <article
                                    className={classNames({
                                        [styles.banner]: true,
                                        [styles.defaultCursor]: !bannerLink,
                                        [styles.sliderItem]: onNewMainPage
                                    })}
                                    key={banner.id ? banner.id : 'slide'+i}
                                    onClick={() => {
                                        if (!isNavigationGuaranteed || !bannerLink) {
                                            return;
                                        }

                                        pushGA(
                                            'PORTAL Banners',
                                            `${getTypeEventActionPrefix(banner)} Click`,
                                            banner.eventLabel ? banner.eventLabel : `Content:bigMain;NAME:${banner.code};`,
                                            banner.heroBanner ? {eventValue: 0, eventUX: 'undefined', eventInteraction: 0 }
                                                : { eventValue: i + 1, eventUX: 'undefined' }
                                        );
                                        analyticsBannerClick(ecomParamsForGA(banner));

                                        if (banner.settings && banner.settings.openLinkInNewTab) {
                                            window.open(bannerLink, '_blank').focus();
                                        } else {
                                            window.location.href = bannerLink;
                                        }
                                    }}
                                >
                                    {
                                        <React.Fragment>
                                            <div
                                                className={styles.image}
                                                style={{
                                                    backgroundColor: imageUrl === '' && banner.saleBanner && banner.saleSettings && banner.saleSettings.bgColor ? banner.saleSettings.bgColor: '',
                                                    backgroundImage: imageUrl ? imageUrl : banner.saleBanner && banner.saleSettings && banner.saleSettings.bgGradient ? banner.saleSettings.bgGradient : '',
                                                    filter: isMobile && !isTablet && settings && settings.setUpOverlayMobile && !!settings.overlayMobile ? `brightness(${settings.overlayMobile})`
                                                    : !isMobile && settings && settings.setUpOverlay && !!settings.overlay ? `brightness(${settings.overlay})`: null
                                                }}
                                            />
                                            {banner?.settings?.custom?.saleBanner && this.renderSaleBanner(banner)}
                                            {banner?.settings.custom?.summerBanner && this.renderSummerBanner(banner)}
                                            {(banner?.settings?.custom?.videoBannerDesktop || banner?.settings?.custom?.videoBannerMobile) && (!banner?.settings?.custom?.saleBanner) && this.renderVideoBanner(banner)}
                                            {!banner?.settings?.custom?.summerBanner && <div className={classNames({
                                                [styles.information]: true,
                                                [styles.saleBannerPosition]: banner.saleBanner,
                                            })}>
                                                {banner.title && (
                                                    <h3
                                                        className={classNames({
                                                            [styles.bannerTitle]: true,
                                                            [styles.bannerTitleMobile]: banner.isMobileFontSize,
                                                        })}
                                                        style={bannerTitleStyle}
                                                        dangerouslySetInnerHTML={{
                                                            __html: isMobile && !isTablet && banner.titleForMobile ? banner.titleForMobile : banner.title,
                                                        }}
                                                    />
                                                )}
                                                {banner.subTitle && (
                                                    <h5
                                                        className={styles.bannerDescription}
                                                        style={{
                                                            color: banner.settings && banner.settings.subTitleColor ? banner.settings.subTitleColor : '#ffffff',
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: !isMobile || isTablet ? banner.subTitle : !banner.subTitleOnlyForDesktop && banner.subTitleForMobile ? banner.subTitleForMobile : '',
                                                        }}
                                                    />
                                                )}
                                            </div>}
                                        </React.Fragment>
                                    }

                                </article>
                            )
                        })}
                    </SliderSlick>
                )}
                </InView>
            </div>
        );
    };
}

const mapStateToProps = state => {
    const { profile, status } = state.User;

    return { profile, status };
};

MainSlider.defaultProps = {
    onNewMainPage: false,
};

MainSlider.propTypes = {
    onNewMainPage: PropTypes.bool,
};

export default injectIntl(connect(mapStateToProps)(MainSlider));
